import { Button } from 'components/shared/Button';
import { FormInputText } from 'components/shared/FormInputText';
import { FC, useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { ChangePasswordData } from 'api/adminApi';
import { changePasswordSchema } from '../SigIn/schema';
import {
  selectLoginData,
  selectRejectedMessage,
  selectChangePasswordStatus,
} from 'redux/admin/selectors';
import { useAppDispatch, useAppSelector } from 'redux/store';
import { Texts } from 'components/shared/Texts';
import styles from '../AdminView.module.scss';
import { fetchChangePassword } from 'redux/admin/thunks';
import { resetLoginData } from 'redux/admin';
import { AdminPanel } from 'utils/strings';

interface ChangePasswordViewProps {
  routeTo: () => void;
}
const ChangePasswordView: FC<ChangePasswordViewProps> = ({ routeTo }) => {
  const dispatch = useAppDispatch();
  const isResetSucceeded = useAppSelector(selectChangePasswordStatus);
  const loginData = useAppSelector(selectLoginData);
  const error = useAppSelector(selectRejectedMessage);
  const handleLogOut = () => void dispatch(resetLoginData());

  useEffect(() => {
    error === AdminPanel.Errors.Api.invalidCredentials && handleLogOut();
    if (isResetSucceeded) {
      routeTo();
    }
  }, [error, isResetSucceeded]);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<ChangePasswordData>({
    defaultValues: {
      oldPassword: '',
      newPassword: '',
    },
    mode: 'onChange',
    resolver: yupResolver(changePasswordSchema),
  });

  const onSubmit = (data: ChangePasswordData) => {
    const bodyData = {
      oldPassword: data.oldPassword,
      newPassword: data.newPassword,
      tokenAccess: loginData?.access_token ?? '',
    };

    void dispatch(fetchChangePassword(bodyData));
  };

  return (
    <section className={styles.login_view}>
      <h1>{AdminPanel.ChangePassword.h1}</h1>
      <form
        className="form"
        onSubmit={(event) => void handleSubmit(onSubmit)(event)}
      >
        <FormInputText
          name="oldPassword"
          placeholder={AdminPanel.oldPassword}
          control={control}
          error={!!errors.oldPassword}
          type="password"
        />
        <FormInputText
          name="newPassword"
          placeholder={AdminPanel.newPassword}
          control={control}
          error={!!errors.newPassword}
          type="password"
        />

        {(error === AdminPanel.Errors.Api.incorrectOldPassword ||
          !!errors.newPassword) && (
          <div className={styles.login_error}>
            <Texts className={styles.error_text}>
              <span className={styles.text_icon}></span>
              {errors.newPassword
                ? errors.newPassword.message
                : AdminPanel.Errors.incorrectPassword}
            </Texts>
          </div>
        )}
        <section>
          <Button className={styles.button_styles} buttonType="submit">
            Zmień hasło
          </Button>
          <Button className={styles.button_styles} onClick={() => routeTo()}>
            Wróć
          </Button>
        </section>
      </form>
    </section>
  );
};
export default ChangePasswordView;
